import { useCallback, useEffect, memo } from 'react';
import TextIcon from '@mui/icons-material/TextFieldsOutlined';
import DateIcon from '@mui/icons-material/CalendarToday';
import GestureIcon from '@mui/icons-material/Gesture';
import _map from 'lodash/map';
import _find from 'lodash/find';
//Local files
import { Root, Text, IconContainer } from './GhostElement.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const GhostElement = ({ newElementType }) => {
  const createDragImage = (node, type) => {
    const iconNodeIndex = _find(_map(node.childNodes, (n, index) => n.id === `ghost_icon_${type}` ? index : n), (node) => Number.isInteger(node));

    node.id = `ghost_${type}`;
    node.style.display = 'flex';
    node.childNodes[iconNodeIndex].style.display = 'flex';

    document.body.appendChild(node);

    setTimeout(() => document.body.removeChild(node));

    return node;
  };
  const handleDragStart = useCallback((e) => {
    const dt = e.dataTransfer;
    const nodeElem = document.getElementById('ghostElement').cloneNode(true);

    if (typeof dt.setDragImage === 'function') {
      const node = createDragImage(nodeElem, e?.target?.id);

      dt.setData('text', e?.target?.id);
      dt.setDragImage(node, 50, 20);
    }
  }, []);

  useEffect(() => {
    !!newElementType && handleDragStart(newElementType);
  }, [newElementType, handleDragStart]);

  return (
    <Root id='ghostElement'>
      <IconContainer id='ghost_icon_date_element'><DateIcon /><Text>Date</Text></IconContainer>
      <IconContainer id='ghost_icon_text_element'><TextIcon /><Text>Text</Text></IconContainer>
      <IconContainer id='ghost_icon_signature_element'><GestureIcon /><Text>Signature</Text></IconContainer>
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <GhostElement {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);